<template>
  <v-card class="card" outlined>
    <div class="card__items">
      <div class="card__contact">
        <v-skeleton-loader type="text" :loading="loading">
          <h1 class="card__title">Our Client Support team is here to help</h1>
        </v-skeleton-loader>

        <v-skeleton-loader type="sentences" :loading="loading">
          <div>
            <div class="card__contact-item">
              <v-img
                class="card__icon"
                src="../../assets/contact-number-icon.svg"
              />
                <contact-no class="ml-4"/>
            </div>
            <div class="card__contact-item">
              <v-img
                class="card__icon"
                src="../../assets/message-primary.svg"
              />
              <email class="ml-4"/>
            </div>
          </div>
        </v-skeleton-loader>
      </div>
      <div class="card__list">
        <v-skeleton-loader type="text" :loading="loading">
          <h5 class="card__list-title">For questions about:</h5>
        </v-skeleton-loader>
        <v-skeleton-loader type="paragraph" :loading="loading">
          <ul class="card__list-items">
            <li>Platform navigation</li>
            <li>Research/data queries</li>
            <li>Green Street products</li>
            <li>Green Street methodologies</li>
            <li>Training needs</li>
            <li>Anything else you need help with!</li>
          </ul>
        </v-skeleton-loader>
      </div>
    </div>
  </v-card>
</template>

<script>
import ContactNo from '../contacts/phone-number.vue'
import Email from '../contacts/email.vue'

export default {
  components: {
    ContactNo,
    Email,
  },
  props: ['tag', 'title', 'description', 'icon', 'loading'],
};
</script>

<style lang="scss" scoped>
.v-skeleton-loader__text {
  background-color: #f0f2f5 !important;
}
.card {
  padding: 16px 32px;
  border: 1px solid #AAE7C5 !important;
  background-color: #EAF8F0;
  border-radius: 4px;
  @media (max-width: 1263px) {
    min-height: initial;
  }
  @media (max-width: 600px) {
    padding: 26px 24px;
  }
  &__title {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.1px;
    margin-bottom: 20px;
  }
  &__items {
    display: grid;
    row-gap: 1.5rem;
    @media (min-width: 600px) {
      column-gap: 1rem;
      grid-template-columns: 50% 50%;
    }
  }
  &__icon {
    max-width: 16px;
  }
  &__contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    p {
      font-size: 12px;
      font-weight: 700;
      line-height: 15px;
      margin-bottom: 0;
      margin-left: 16px;
    }
  }
  &__list {
    display: grid;
    row-gap: 8px;
  }
  &__list-title {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #7b7d7a;
    margin-bottom: 4px;
  }
  &__list-items {
    display: grid;
    grid-auto-flow: dense;
    row-gap: 4px;
    column-gap: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: #7b7d7a;
    list-style: none;
    padding-left: 20px;
    > li {
      vertical-align: middle;
      @media (min-width: 768px) {
        grid-column-start: 1;
        &:nth-child(n+4) {
          grid-column-start: 2;
        }
      }
    }
    > li::before {
      content: '\2022';
      color: var(--v-primary-base);
      display: inline-block;
      font-size: 1.5rem;
      line-height: 0.5rem;
      width: 1rem;
      margin-left: -1rem;
    }
    @media (min-width: 768px) {
      grid-template-columns: auto auto;
    }
  }
}
</style>

<style scoped>
.card >>> .v-skeleton-loader__text {
  background-color: #f0f2f5 !important;
}
.card ul.questions {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1px;
  color: #7b7d7a;
  list-style: none;
}
ul.questions > li {
  vertical-align: middle;
}
ul.questions > li::before {
  content: '\2022';
  color: var(--v-primary-base);
  display: inline-block;
  font-size: 1.5rem;
  line-height: 0.5rem;
  width: 1rem;
  margin-left: -1rem;
}

@media screen and (min-width: 1264px) {
  ul.questions > li::before {
    font-size: 1rem;
  }
}
</style>
